/**
 * État runtime du mode démo.
 *
 * Module PUR (aucune dépendance) — copié tel quel dans la codebase mobile.
 * Les flags sont synchronisés depuis le store Redux (web) ou le contexte
 * (mobile) ; les couches d'accès aux données (proxy Firestore…) les lisent à
 * chaque livraison de snapshot, si bien que les toggles agissent sans
 * re-création des instances Firebase.
 *
 * Deux réglages :
 * - actif        : le mode démo (substitution des noms)
 * - photosActive : sous-option — substituer aussi les photos par des photos
 *                  factices (réglable au moment de l'activation)
 */

let active = false;
let photosActive = true;
const listeners = new Set();

export function isDemoActive() {
  return active;
}

/** Photos factices : seulement pertinent quand le mode démo est actif. */
export function isDemoPhotosActive() {
  return active && photosActive;
}

function notify() {
  listeners.forEach((listener) => {
    try {
      listener(active);
    } catch (error) {
      console.error("demoState listener error", error);
    }
  });
}

export function setDemoActive(value) {
  const next = !!value;
  if (next === active) return;
  active = next;
  notify();
}

export function setDemoPhotosActive(value) {
  const next = value === undefined ? true : !!value;
  if (next === photosActive) return;
  photosActive = next;
  notify();
}

/** Abonne un callback aux changements de réglages. Retourne la fonction de désabonnement. */
export function onDemoModeChange(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
